import { apiFetchInit, apiOrigin } from "@/lib/apiOrigin";
import { isDashboardOrgSegment } from "@/lib/dashboardOrg";

export function isValidDirectoryOrgId(orgId: string | null | undefined): orgId is string {
  const v = (orgId || "").trim();
  return isDashboardOrgSegment(v);
}

export async function postSessionOrgUpdate(orgId: string): Promise<void> {
  const trimmed = orgId.trim();
  if (!isDashboardOrgSegment(trimmed)) {
    throw new Error("Invalid organization id");
  }
  const origin = apiOrigin();
  const csrfRes = await fetch(`${origin}/api/auth/csrf`, {
    credentials: "include",
    cache: "no-store",
    ...apiFetchInit(),
  });
  const csrfPayload = (await csrfRes.json()) as { csrfToken?: string };
  if (!csrfRes.ok || !csrfPayload.csrfToken) {
    throw new Error("Could not refresh session");
  }
  const res = await fetch(`${origin}/api/auth/session`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    cache: "no-store",
    ...apiFetchInit(),
    body: JSON.stringify({ csrfToken: csrfPayload.csrfToken, data: { orgId: trimmed } }),
  });
  if (!res.ok) throw new Error("Could not switch organization");
}
